import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/5.jpg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonToxanov = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Токсанов Сапар Нурахметович</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>PhD in Information Systems</MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={"https://www.scopus.com/authid/detail.uri?authorId=57222154960"}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={"https://orcid.org/0000-0002-2915-9619"}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>ТОО «Astana IT University», проректор по воспитательной работе</MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Научный сотрудник</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Создание моделей облачной архитектуры программного комплекса (микросервисы);
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка методов передачи данных с первичных измерителей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка ИИС сбора и обработки неструктурированных данных, API для взаимодействия с внешними системами.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR24993128 «Разработка ИАС трансграничных водных ресурсов» (2024-2026) — научный сотрудник.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR21882258 «Экологический мониторинг эмиссий» (2023-2025).
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - AP19678730, AP19678627, AP23490123, BR18574103 — участие в грантовых проектах.
                </MyText>
            </Flex>
        </Flex>
    );
};
